// VoltaGrid WBS roll-up: Job (L1) -> Section (L2) -> Group (L3) -> Cost Code.
// Generated by localserver/scripts/wbs_voltagrid_build.py from "VoltaGrid Estimate Export 2026.09.15.xlsx"
// ("WBS Clean" sheet) - regenerate rather than editing by hand.
//
// `open` is whether the workbook was saved with that section expanded to its
// groups; the client cost report prints at exactly that level.
import { standardDisciplineFor } from './wbsStandard';

export const VG_SECTIONS = [
    { no: 1, name: "Indirects", open: false, groups: ["General Services", "Mob/Demob", "Temporary Facilities", "Construction Layout/Surv", "Stand By", "Weather Delay", "Mats-Haul/Place/Remove"] },
    { no: 2, name: "Piping", open: false, groups: ["NDE", "Piping"] },
    { no: 3, name: "Coating", open: false, groups: ["Coating"] },
    { no: 4, name: "Equipment", open: true, groups: ["Grouting", "Installation Qpac 07-01", "Installation Qpac 07-02", "Installation Qpac 07-03", "Installation Qpac 07-04", "Installation Qpac 07-05", "Installation Qpac 07-06", "Installation Qpac 08-07", "Installation Qpac 08-08", "Installation Qpac 08-09", "Installation Qpac 08-10", "Installation Qpac 08-11", "Installation Qpac 09-01", "Installation Qpac 09-02", "Installation Qpac 09-03", "Installation Qpac 09-04", "Installation Qpac 09-05", "Installation Qpac 10-06", "Installation Qpac 10-07", "Installation Qpac 10-08", "Installation Qpac 10-09", "Installation Qpac 10-10", "Equipment – Balance of Plant"] },
    { no: 5, name: "Electrical", open: true, groups: ["Electrical Equipment", "Cable Tray", "Conduit – AG", "Conduit – UG", "Wire and Cable", "Terminations", "Testing/Commissioning", "Civil/Concrete", "T&M", "UG Dirtwork"] },
    { no: 6, name: "Instrumentation", open: false, groups: ["Instrumentation"] },
    { no: 7, name: "Structural Steel", open: false, groups: ["Structural Steel"] },
    { no: 8, name: "Commissioning", open: false, groups: ["Hydrotesting", "Restoration", "Commissioning"] },
];

// cost code -> [section no, index into that section's groups]
export const VG_CODES = {
    '100101': [1, 0],
    '100105': [1, 0],
    '100201': [1, 0],
    '100401': [1, 1],
    '100402': [1, 1],
    '100601': [1, 2],
    '100602': [1, 2],
    '100603': [1, 2],
    '100607': [1, 2],
    '100801': [1, 3],
    '100901': [1, 0],
    '100903': [1, 4],
    '101001': [1, 5],
    '120201': [5, 0],
    '120202': [5, 0],
    '120203': [5, 0],
    '120214': [5, 0],
    '120301': [6, 0],
    '120302': [6, 0],
    '120303': [6, 0],
    '120304': [6, 0],
    '120305': [6, 0],
    '120501': [5, 1],
    '120601': [5, 2],
    '120602': [5, 2],
    '120603': [5, 2],
    '120604': [5, 2],
    '120605': [5, 2],
    '120606': [5, 2],
    '120607': [5, 2],
    '120608': [5, 2],
    '120610': [5, 3],
    '120611': [5, 3],
    '120612': [5, 3],
    '120613': [5, 3],
    '120614': [5, 3],
    '120615': [5, 3],
    '120616': [5, 3],
    '120617': [5, 3],
    // 10/2 the UG conduit moved to 220610; 10/7 it was split by size (vg71-day-zero-build.py). Same WBS line as 12061x.
    '220610': [5, 3],
    '220612': [5, 3],
    '220630': [5, 3],
    '220631': [5, 3],
    '220632': [5, 3],
    '220633': [5, 3],
    '220634': [5, 3],
    '220635': [5, 3],
    '220636': [5, 3],
    '220637': [5, 3],
    '120620': [5, 2],
    '120621': [5, 2],
    '120622': [5, 2],
    '120623': [5, 2],
    '120624': [5, 2],
    '120625': [5, 2],
    '120626': [5, 2],
    '120627': [5, 2],
    '120630': [5, 3],
    '120631': [5, 3],
    '120632': [5, 3],
    '120633': [5, 3],
    '120634': [5, 3],
    '120635': [5, 3],
    '120636': [5, 3],
    '120637': [5, 3],
    '120801': [5, 4],
    '120802': [5, 4],
    '120803': [5, 4],
    '120804': [5, 4],
    '120805': [5, 4],
    '120901': [5, 5],
    '120902': [5, 5],
    '120903': [5, 5],
    '121001': [5, 6],
    '121002': [5, 6],
    '130607': [5, 7],
    '130608': [5, 7],
    '140401': [1, 6],
    '141201': [3, 0],
    '141601': [2, 0],
    '141710': [8, 0],
    '142006': [8, 1],
    '150201': [4, 0],
    '150301': [4, 0],
    '160201': [2, 1],
    '160317': [2, 1],
    '160321': [2, 1],
    '160322': [2, 1],
    '160323': [2, 1],
    '160332': [3, 0],
    '160334': [2, 1],
    '160402': [8, 2],
    '160507': [7, 0],
    '160508': [7, 0],
    '160510': [7, 0],
    '160605': [7, 0],
    '161602': [2, 1],
    '195250': [5, 8],
    '195251': [4, 1],
    '195252': [4, 1],
    '195253': [4, 1],
    '195254': [4, 1],
    '195255': [4, 1],
    '195256': [4, 1],
    '195257': [4, 1],
    '195259': [4, 2],
    '195260': [4, 2],
    '195261': [4, 2],
    '195262': [4, 2],
    '195263': [4, 2],
    '195264': [4, 2],
    '195265': [4, 2],
    '195267': [4, 3],
    '195268': [4, 3],
    '195269': [4, 3],
    '195270': [4, 3],
    '195271': [4, 3],
    '195272': [4, 3],
    '195273': [4, 3],
    '195275': [4, 4],
    '195276': [4, 4],
    '195277': [4, 4],
    '195278': [4, 4],
    '195279': [4, 4],
    '195280': [4, 4],
    '195281': [4, 4],
    '195283': [4, 5],
    '195284': [4, 5],
    '195285': [4, 5],
    '195286': [4, 5],
    '195287': [4, 5],
    '195288': [4, 5],
    '195289': [4, 5],
    '195291': [4, 6],
    '195292': [4, 6],
    '195293': [4, 6],
    '195294': [4, 6],
    '195295': [4, 6],
    '195296': [4, 6],
    '195297': [4, 6],
    '195299': [4, 7],
    '195350': [4, 7],
    '195351': [4, 7],
    '195352': [4, 7],
    '195353': [4, 7],
    '195354': [4, 7],
    '195355': [4, 7],
    '195357': [4, 8],
    '195358': [4, 8],
    '195359': [4, 8],
    '195360': [4, 8],
    '195361': [4, 8],
    '195362': [4, 8],
    '195363': [4, 8],
    '195365': [4, 9],
    '195366': [4, 9],
    '195367': [4, 9],
    '195368': [4, 9],
    '195369': [4, 9],
    '195370': [4, 9],
    '195371': [4, 9],
    '195373': [4, 10],
    '195374': [4, 10],
    '195375': [4, 10],
    '195376': [4, 10],
    '195377': [4, 10],
    '195378': [4, 10],
    '195379': [4, 10],
    '195381': [4, 11],
    '195382': [4, 11],
    '195383': [4, 11],
    '195384': [4, 11],
    '195385': [4, 11],
    '195386': [4, 11],
    '195387': [4, 11],
    '195389': [4, 12],
    '195390': [4, 12],
    '195391': [4, 12],
    '195392': [4, 12],
    '195393': [4, 12],
    '195394': [4, 12],
    '195395': [4, 12],
    '195397': [4, 13],
    '195398': [4, 13],
    '195399': [4, 13],
    '295250': [4, 13],
    '295251': [4, 13],
    '295252': [4, 13],
    '295253': [4, 13],
    '295255': [4, 14],
    '295256': [4, 14],
    '295257': [4, 14],
    '295258': [4, 14],
    '295259': [4, 14],
    '295260': [4, 14],
    '295261': [4, 14],
    '295263': [4, 15],
    '295264': [4, 15],
    '295265': [4, 15],
    '295266': [4, 15],
    '295267': [4, 15],
    '295268': [4, 15],
    '295269': [4, 15],
    '295271': [4, 16],
    '295272': [4, 16],
    '295273': [4, 16],
    '295274': [4, 16],
    '295275': [4, 16],
    '295276': [4, 16],
    '295277': [4, 16],
    '295279': [4, 17],
    '295280': [4, 17],
    '295281': [4, 17],
    '295282': [4, 17],
    '295283': [4, 17],
    '295284': [4, 17],
    '295285': [4, 17],
    '295287': [4, 18],
    '295288': [4, 18],
    '295289': [4, 18],
    '295290': [4, 18],
    '295291': [4, 18],
    '295292': [4, 18],
    '295293': [4, 18],
    '295295': [4, 19],
    '295296': [4, 19],
    '295297': [4, 19],
    '295298': [4, 19],
    '295299': [4, 19],
    '295350': [4, 19],
    '295351': [4, 19],
    '295353': [4, 20],
    '295354': [4, 20],
    '295355': [4, 20],
    '295356': [4, 20],
    '295357': [4, 20],
    '295358': [4, 20],
    '295359': [4, 20],
    '295361': [4, 21],
    '295362': [4, 21],
    '295363': [4, 21],
    '295364': [4, 21],
    '295365': [4, 21],
    '295366': [4, 21],
    '295367': [4, 21],
    '295368': [4, 22],
    '295369': [4, 22],
    '295370': [4, 22],
    '295371': [4, 22],
    // 54026071 budgets UG electrical trenching / backfill on the 2306xx codes
    // the estimate export never carried; they print under Electrical as UG Dirtwork.
    '230607': [5, 9],
    '230608': [5, 9],
};
// 10/8 (Aeron): Grouting rolls into Equipment - Balance of Plant on the
// client's view. Overrides the generated [4, 0] (Grouting) entries above.
export const VG_BALANCE_OF_PLANT = 'Equipment – Balance of Plant';
const BOP_INDEX = VG_SECTIONS.find((x) => x.no === 4).groups.indexOf(VG_BALANCE_OF_PLANT);
VG_CODES['150201'] = [4, BOP_INDEX];
VG_CODES['150301'] = [4, BOP_INDEX];

// The WBS group a cost code prints under, for a page that already knows the
// code's discipline. A code the bid WBS never listed goes to Balance of Plant
// when the page files it under Equipment (Aeron, 10/8), else to 'Other'.
export function voltaGridGroupFor(code, discipline) {
    const hit = voltaGridWbsFor(code);
    if (hit) return { group: hit.group, order: hit.groupOrder };
    if (/^equipment$/i.test(String(discipline || '').trim())) return { group: VG_BALANCE_OF_PLANT, order: BOP_INDEX };
    return { group: 'Other', order: 999 };
}

// Posted cost codes the estimate never carried (100102 indirect equipment,
// 100303 safety supplies ...) still need a home on the client's WBS. The
// standard discipline says which indirect group they belong to; anything else
// returns null and the report files it under Unassigned Scope, where it is
// seen rather than guessed at.
const FALLBACK = {
    'Project Support': [1, 'General Services'],
    'Mob / Demob': [1, 'Mob/Demob'],
};

// Returns { no, name, order, open, group, groupOrder } for a cost code, else null.
export function voltaGridWbsFor(code) {
    const c = (code === undefined || code === null ? '' : code + '').trim();
    let hit = VG_CODES[c];
    if (!hit) {
        const std = standardDisciplineFor(c);
        const fb = std && FALLBACK[std.discipline];
        if (!fb) return null;
        const s = VG_SECTIONS.find((x) => x.no === fb[0]);
        hit = [fb[0], s.groups.indexOf(fb[1])];
    }
    const sec = VG_SECTIONS.find((x) => x.no === hit[0]);
    return { no: sec.no, name: sec.name, order: sec.no, open: sec.open, group: sec.groups[hit[1]], groupOrder: hit[1] };
}

// Where a discipline sorts on the VoltaGrid Overview: a bid section at its
// place in VG_SECTIONS; a discipline the job named itself ("AG Electrical
// Conduit", "UG Electrical") right after the bid section most of its codes
// roll up to (Aeron, 10/22); anything else after every section.
export function voltaGridDisciplineRank(discipline, codes = []) {
    const i = VG_SECTIONS.findIndex((x) => x.name.toLowerCase() === String(discipline).toLowerCase());
    if (i >= 0) return i;
    const sec = homeSection(codes);
    return sec ? VG_SECTIONS.indexOf(sec) + 0.5 : 99;
}

// The bid section most of these codes roll up to in the client WBS, else null.
function homeSection(codes) {
    const count = {};
    codes.forEach((c) => { const no = voltaGridWbsFor(c)?.no; if (no) count[no] = (count[no] || 0) + 1; });
    const nos = Object.keys(count).map(Number).sort((a, b) => count[b] - count[a] || a - b);
    return nos.length ? VG_SECTIONS.find((x) => x.no === nos[0]) : null;
}

// Folds a discipline the job named itself into the bid section its codes roll
// up to, when that section opens to rows under it on the Overview (Equipment,
// Electrical): AG Electrical Conduit and UG Electrical show in the Electrical
// group (Aeron, 10/22). Takes { code: discipline }; returns the folded map,
// the job's own name for each folded code (`subgroup`), and where each such
// name sorts among the section's WBS groups (`order`: its first group's).
export function foldVoltaGridDisciplines(mapping) {
    const codesOf = {};
    Object.entries(mapping).forEach(([cc, d]) => { (codesOf[d] || (codesOf[d] = [])).push(cc); });
    const parent = {};
    const order = {};
    Object.keys(codesOf).forEach((d) => {
        if (d === 'Other' || d === 'Contingency' || VG_SECTIONS.some((x) => x.name.toLowerCase() === String(d).toLowerCase())) return;
        const sec = homeSection(codesOf[d]);
        if (!sec || !sec.open) return;
        parent[d] = sec.name;
        const orders = codesOf[d].map((c) => voltaGridWbsFor(c)).filter((h) => h && h.no === sec.no).map((h) => h.groupOrder);
        order[d] = Math.min(...orders);
    });
    const folded = {};
    const subgroup = {};
    Object.entries(mapping).forEach(([cc, d]) => {
        if (parent[d]) { folded[cc] = parent[d]; subgroup[cc] = d; } else folded[cc] = d;
    });
    return { mapping: folded, subgroup, order };
}
